import { Component, OnInit, inject } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { loadQuotaSummary, selectQuotaSummary, selectQuotaLoaded } from '../../../store/quota';

@Component({
  selector: 'app-quota-summary-bar',
  standalone: true,
  imports: [CommonModule, DecimalPipe, TranslateModule],
  templateUrl: './quota-summary-bar.html',
  styleUrl: './quota-summary-bar.css'
})
export class QuotaSummaryBarComponent implements OnInit {
  private store = inject(Store);

  summary$ = this.store.select(selectQuotaSummary).pipe(
    map(items => {
      const seen = new Set<string>();
      return (items ?? []).filter(item => {
        if (seen.has(item.meatTypeName)) return false;
        seen.add(item.meatTypeName);
        return true;
      });
    })
  );
  loaded$ = this.store.select(selectQuotaLoaded);

  ngOnInit(): void {
    this.store.select(selectQuotaLoaded).subscribe(loaded => {
      if (!loaded) {
        this.store.dispatch(loadQuotaSummary());
      }
    });
  }
}
